import { useNavigate } from 'react-router-dom';

interface PointsModalProps {
  isOpen: boolean;
  onClose: () => void;
  cost: number | undefined;
}

export default function PointsModal({ isOpen, onClose, cost }: PointsModalProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-5">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-white rounded-3xl p-6 w-full max-w-sm animate-scale-in">
        <div className="w-14 h-14 rounded-2xl mx-auto mb-4 flex items-center justify-center bg-amber-50">
          <i className="ri-coin-line text-amber-500 text-2xl"></i>
        </div>
        <h3 className="text-lg font-bold text-gray-800 text-center mb-2">{t('gen_pointsInsufficient')}</h3>
        <p className="text-sm text-gray-500 text-center mb-5">
          {t('gen_pointsInsufficientDesc', { cost: cost ?? '' })}
        </p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl bg-gray-100 text-gray-700 font-medium text-sm cursor-pointer whitespace-nowrap"
          >
            {t('gen_cancel')}
          </button>
          <button
            onClick={() => {
              onClose();
              navigate('/membership');
            }}
            className="flex-1 py-3 rounded-xl text-white font-medium text-sm cursor-pointer whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #FF6B9D, #A855F7)' }}
          >
            {t('gen_openMembership')}
          </button>
        </div>
      </div>
    </div>
  );
}